const url =process.env.REACT_APP_API_URL;
export const ROUTES={
    LOGIN: `${url}login`,
    REGISTER: `${url}register`,
    EMPLOYEE_LIST: `${url}employee/list`,
    EMPLOYEE_LIST_BY_FILTER: `${url}employee`,
    EMPLOYEE_REPORT_LIST: `${url}employee/performance/reports`,
    EMPLOYEE_BY_ID: `${url}employee/`,
    PRODUCT_LIST: `${url}product/list`,
    DISTRIBUTOR_LIST: `${url}distributor/list`,
    DISTRIBUTOR_LIST_BY_FILTER: `${url}distributor`,
    DISTRIBUTOR_BY_ID: `${url}distributor/`,
    SALES_LIST: `${url}sale/list`,
    SALES_BY_ID: `${url}sale/`,
    SALES_LIST_BY_TRIP: `${url}sale`,
    EMPLOYEE_SALES_LIST: `${url}sale/employees`,
    DISTRIBUTOR_SALES_LIST: `${url}sale/distributors`,
    GET_SALES_LIST_BY_EMPLOYEE: `${url}sale/employee/`,
    SALES_STATE_LIST: `${url}sale/state/list`,
    TODAY_SALES_LIST: `${url}sale/all/today-sales`,
    TODAY_MTD_SALES: `${url}sale/all/mtd/sales`,
    SHOP_LIST: `${url}shop/list`,
    SHOP_FILTER: `${url}shop`,
    SHOP_BY_ID: `${url}shop/`,
    TRIPS_LIST: `${url}trip/list`,
    TRIP_BY_ID: `${url}trip/`,
    GET_ALL_ATTENDANCE:`${url}attendance/list`,
    GET_ALL_ATTENDANCE_BY_EMPLOYEE:`${url}attendance/`,
    REPORT_ATTENDANCE:`${url}attendance/report`,
    REPORT_EMPLOYEE_PERFORMANCE:`${url}employee/report/performance`,
    REPORT_PARTY_DETAILS:`${url}distributor/reports/stock`,
    GET_ALL_DAY_SALES:`${url}sale/report`,
    GET_ALL_DISTRIBUTOR_STOCKS:`${url}stocks`,
    UNLOGGED_EMPLOYEES: `${url}employee/unlogged/list`,
    EMPLOYEES_ATTENDANCE_REPORT: `${url}employee/attendance/report`,
    BEAT_LIST: `${url}beats/list`,
    BEAT_BY_ID: `${url}beats/`,
    ADD_BEAT: `${url}beats`,
}